import React from "react";
import "./Plan.css";
import { plansData } from "../../data/plansData";
import whiteTick  from "../../assets/whiteTick.png";
const Plan = () => {
  return (
    <div className="Plan-container">
      <div className="blur plan-blur1"></div>
      <div className="blur plan-blur2"></div>
      <div className="plan-header">
        <span>READY TO START </span>
        <span className="stroke-text">YOUR JOURNEY</span>
        <span>WITH US</span>
      </div>
      <div className="plans">
        {plansData.map((plan, i) => (
          <div className="plan" key={i}>
            {plan.icon}
            <span>{plan.name}</span>
            <span>$ {plan.price}</span>

            <div className="features">
              {plan.features.map((feature, i) => (
                <div className="feature">
                  <img src={whiteTick} alt="" />
                  <span key={i}>{feature}</span>
                </div>
              ))}
            </div>
            <div>
              <span>Know More benefit </span>
            </div>
            <div>
              <button className="btn">Join Now</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Plan;
